export default {
  // Page title and subtitle
  'page.mainTitle': 'Unixタイムスタンプコンバーター',
  'page.mainTitleSEO': 'Unixタイムスタンプコンバーター & エポックタイムツール',
  'page.subtitle': 'Unixタイムスタンプと日時を瞬時に相互変換',
  'page.title': 'タイムスタンプコンバーター',
  'page.currentTimestamp': '現在のUnixタイムスタンプ',
  'page.currentEpochTime': '現在のUnixエポックタイム',
  'page.milliseconds': 'ミリ秒（13桁）',
  'page.seconds': '秒（10桁）',
  'page.millisecondsOnly': 'ミリ秒',
  'page.secondsOnly': '秒',
  'page.currentDateTime': '現在の日時',

  // Interactive Converter
  'page.interactiveConverter': 'インタラクティブタイムスタンプ ↔ 日付コンバーター',
  'page.timestampToDatetimeTitle': 'Unixタイムスタンプから日時へ',
  'page.datetimeToTimestampTitle': '日時からタイムスタンプへ',
  'page.ms': 'ミリ秒',
  'page.sec': '秒',
  'page.autoDetect': '自動検出フォーマット',
  'page.detected': '検出',
  'page.digits': '桁',
  'page.convertedTo': '変換先',
  'page.converterTip': 'リアルタイム双方向変換',
  'page.converterTipDesc': 'どちらのフィールドに入力しても瞬時に変換が表示されます。10桁（秒）または13桁（ミリ秒）のタイムスタンプを自動検出します。',

  // Conversion sections
  'page.timestampToDateTime': 'タイムスタンプから日時へ',
  'page.dateTimeToTimestamp': '日時からタイムスタンプへ',
  'page.selectFormat': 'フォーマットを選択',
  'page.enterTimestamp': 'タイムスタンプを入力',
  'page.enterDateTime': '日時を選択',
  'page.convertedResult': '変換結果',
  'page.yourTimeZone': 'あなたのタイムゾーン',
  'page.relative': '相対',

  // Relative time translations
  'page.relativeTime.secondsAgo': '{{seconds}}秒前',
  'page.relativeTime.minutesAgo': '{{minutes}}分前',
  'page.relativeTime.hoursAgo': '{{hours}}時間前',
  'page.relativeTime.daysAgo': '{{days}}日前',
  'page.relativeTime.inSeconds': '{{seconds}}秒後',
  'page.relativeTime.inMinutes': '{{minutes}}分後',
  'page.relativeTime.inHours': '{{hours}}時間後',
  'page.relativeTime.inDays': '{{days}}日後',

  // What is Timestamp section (FAQ)
  'page.faq': 'よくある質問（FAQ）',
  'page.whatIsTimestamp': 'Unixタイムスタンプとは？',
  'page.timestampIntro': 'Unixタイムスタンプ（エポックタイムまたはPOSIXタイムとも呼ばれる）は、1970年1月1日00:00:00 UTC（Unixエポック）からの経過秒数（またはミリ秒数）として時点を表すシステムです（うるう秒を除く）。この標準は、日付と時刻を表現するシンプルで普遍的な方法として、コンピューティングとプログラミングで広く使用されています。',

  'page.unixEpochTitle': 'Unixエポック - 時間の始まり',
  'page.unixEpochDesc': 'Unixエポックは1970年1月1日の深夜UTCです。すべてのUnixタイムスタンプはこの特定の時点から計算され、世界中のコンピューターシステムの普遍的な基準点となっています。',

  'page.timestampFormatsTitle': 'タイムスタンプフォーマット',
  'page.secondsFormat': '秒（10桁）',
  'page.secondsFormatDesc': 'エポックからの秒数を表す標準Unixタイムスタンプ。例：1734598784',
  'page.millisecondsFormat': 'ミリ秒（13桁）',
  'page.millisecondsFormatDesc': 'ミリ秒精度の拡張タイムスタンプ。例：1734598784000',

  'page.whyUseTimestampTitle': 'なぜUnix時間を使用するのか？',
  'page.reason1Title': 'タイムゾーン独立',
  'page.reason1Desc': 'タイムスタンプはUTC時間を表し、グローバルアプリケーションでのタイムゾーンの混乱を排除します。',
  'page.reason2Title': '簡単な計算',
  'page.reason2Desc': '時間差や期間を計算するための簡単な算術演算。',
  'page.reason3Title': 'データベースフレンドリー',
  'page.reason3Desc': 'データベースのインデックス作成とソートに最適なコンパクトな整数ストレージフォーマット。',
  'page.reason4Title': '普遍的な標準',
  'page.reason4Desc': '事実上すべてのプログラミング言語とプラットフォームでサポートされています。',
  'page.year2038Problem': '2038年に何が起こる？（2038年問題）',
  'page.year2038Content': '2038年問題（Y2038またはUnixミレニアムバグとも呼ばれる）は、32ビットUnixタイムスタンプがオーバーフローする時を指します。2038年1月19日03:14:07 UTCに、符号付き32ビット整数が最大値（2,147,483,647）に達し、負の数に巻き戻ります。64ビットタイムスタンプを使用する最新のシステムは影響を受けず、何十億年も先の日付を表現できます。',

  // Coding examples section
  'page.codingExamples': '異なるプログラミング言語で現在のタイムスタンプを取得する方法',
  'page.codeCheatSheet': 'Unixタイムスタンプコードチートシート（言語別）',
  'page.howToGetTimestamp': '現在のタイムスタンプを取得する方法',
  'page.convertToDate': 'タイムスタンプを日付オブジェクトに変換',
  'page.convertToTimestamp': '日付をタイムスタンプに変換',
  'page.getCurrentTimestamp': '現在のタイムスタンプを取得',
  'page.getMilliseconds': 'ミリ秒タイムスタンプを取得',
  'page.getSeconds': '秒タイムスタンプを取得',

  // Timestamp to Date conversion examples
  'page.timestampToDateExamples': 'Unixタイムスタンプを日付/時刻に変換する方法',
  'page.timestampToDateDesc': '様々なプログラミング言語でUnixタイムスタンプを人間が読める日付と時刻のフォーマットに変換する方法を学びます。秒またはミリ秒のタイムスタンプがある場合でも、これらの例は適切な変換方法を示しています。',
  'page.convertTimestampToDate': 'タイムスタンプを日付に変換',
  'page.fromMilliseconds': 'ミリ秒タイムスタンプから',
  'page.fromSeconds': '秒タイムスタンプから',
  'page.formatOptions': 'カスタムオプションでフォーマット',
  'page.toUTC': 'UTCに変換',
  'page.formatDate': '日付をフォーマット',

  // Date to Timestamp conversion examples
  'page.dateToTimestampExamples': '日付/時刻をUnixタイムスタンプに変換する方法',
  'page.dateToTimestampDesc': '異なるプログラミング言語で日付と時刻をUnixタイムスタンプに変換する方法を学びます。これらの例は、日付文字列の解析、日付コンポーネントからのタイムスタンプの作成、秒とミリ秒の両方のフォーマットの処理を示しています。',
  'page.convertDateToTimestamp': '日付をタイムスタンプに変換',
  'page.fromDateString': '日付文字列から',
  'page.fromDateComponents': '日付コンポーネントから',
  'page.parseString': '日付文字列を解析',
  'page.monthNote': '注：月は0から始まるインデックス',
  'page.useCalendar': 'カレンダーを使用',
  'page.parseFormat': 'フォーマットで解析',
  'page.fromComponents': '時間コンポーネントから',
  'page.currentTime': '現在のタイムスタンプを取得',
  'page.fromDatetime': 'datetime列から',

  // How to use
  'page.howToUse': 'このタイムスタンプコンバーターの使い方',
  'page.step1': '📊 現在のタイムスタンプ：秒（10桁）とミリ秒（13桁）フォーマットの両方でリアルタイムのUnixタイムスタンプを表示。コピーボタンをクリックすると、タイムスタンプをクリップボードにすばやくコピーできます。',
  'page.step2': '🔄 タイムスタンプから日時へ：Unixタイムスタンプを入力し、秒またはミリ秒フォーマットかを選択します。変換をクリックすると、GMT、ローカルタイムゾーン、ISO 8601、相対時間を含む複数のフォーマットで対応する日時が表示されます。',
  'page.step3': '📅 日時からタイムスタンプへ：日付ピッカーを使用して任意の日時を選択するか、「現在」をクリックして現在時刻を使用します。変換すると、秒とミリ秒の両方のタイムスタンプフォーマットが瞬時に取得できます。',
  'page.step4': '💡 クイックヒント：Unixタイムスタンプは1970年1月1日00:00:00 UTCからの秒数/ミリ秒数です。秒には10桁フォーマット、ミリ秒には13桁フォーマットを使用します。すべての変換は瞬時で、オフラインで動作します。',

  // Related Tools
  'page.relatedTools': '関連時間ツール',
  'page.relatedToolsDesc': '他のプロフェッショナルな時間管理ツールを探索',
  'page.timerTool': 'オンラインタイマー',
  'page.timerToolDesc': 'ポモドーロテクニック、料理、学習、作業休憩に最適なカウントダウンタイマー',
  'page.stopwatchTool': 'ストップウォッチ',
  'page.stopwatchToolDesc': 'スポーツトレーニングと計時のためのミリ秒精度の高精度ストップウォッチ',
  'page.worldClockTool': '世界時計',
  'page.worldClockToolDesc': '世界主要都市の現在時刻を表示するリアルタイム世界時計',

  // Specialized Tools
  'page.specializedTools': '専門タイムスタンプツール',
  'page.specializedToolsDesc': '異なるプラットフォームとユースケースのための専門タイムスタンプツールを探索',
  'page.discord.desc': 'Discord イベント用の <t:format> コードを自動タイムゾーン変換で生成',
  'page.discord.topSearch': '最高検索',
  'page.discord.searchesPerMonth': '月間検索',
  'page.youtube.desc': '特定の時間から開始する共有可能なYouTubeリンクを作成',
  'page.youtube.popular': '人気',

  // Programming Guides
  'page.programmingGuides': 'プログラミング言語タイムスタンプガイド',
  'page.programmingGuidesDesc': '各プログラミング言語のタイムスタンプ処理方法、関数、ベストプラクティスを学ぶ',
  'page.sql.desc': 'MySQL、PostgreSQL、Oracle、SQL Server のタイムスタンプ処理',
  'page.sql.highPriority': '高優先度',
  'page.sql.searches': '検索',
  'page.python.desc': 'datetime、time、calendar モジュールガイド',
  'page.python.popular': '人気',
  'page.javascript.desc': 'Date オブジェクト、Day.js、date-fns ライブラリガイド',
  'page.javascript.common': '一般的',
  'page.codeExamplesNote': '完全なコード例、ベストプラクティス、FAQを含む',
};
